import { render, staticRenderFns } from "./appViewer.vue?vue&type=template&id=08e64ffe&scoped=true&"
import script from "./appViewer.vue?vue&type=script&lang=js&"
export * from "./appViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e64ffe",
  null
  
)

export default component.exports